import Notifications from "../../../../pages/Others/Notifications";

const routerNotifications = [
    {
        key: "notifications",
        path: "/notifications",
        element: <Notifications />,
    },
]

export default routerNotifications
